import {Component, OnInit} from '@angular/core';
import {PrivateAreaService} from '../../services/private-area.service';
import {modifyDataForm} from '../../../Assets/angular/assets/data/forms/modify_data_form';
import {modifyPhoneForm} from '../../../Assets/angular/assets/data/forms/modify_phone_form';
import {ClientData} from '../../models/interface-client-data';

@Component({
    selector: 'app-personal-data',
    templateUrl: './personal-data.component.html',
    styleUrls: ['./personal-data.component.scss']
})
export class PersonalDataComponent implements OnInit {

    personalData: ClientData;
    modifyDataForm: Array<object>;
    modifyPhoneForm: Array<object>;
    showLoader: boolean;
    errormessage: string;

    constructor(public privateAreaService: PrivateAreaService) {
        this.modifyDataForm = modifyDataForm;
        this.modifyPhoneForm = modifyPhoneForm;
        this.showLoader = true;
    }

    ngOnInit(): void {
        this.privateAreaService.getClientData().subscribe(res => {
            this.personalData = res;
            this.showLoader = false;
        }, error => {
            this.showLoader = false;
            this.errormessage = 'Algo ha fallado, intentalo mas tarde.';
        });
    }

}
